import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {Title} from "../../../../../../stories/Title/Title";
import {Button} from "../../../../../../stories/Button/Button";
import {useNavigate} from "react-router-dom";
import {Label} from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import {
  GridColDef,
  GridValidRowModel,
  GridAlignment,
  GridCellParams,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import {msgType, TableHeaderProps} from "../../../../../../utils/types";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import {Keys, SpecialKeys} from "../../../../../../utils/Enum.keys";
import {
  CustomModal,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";

import {StyledDatagrid} from "../../../../../../styles/DatagridStyles";
import {TABLE_ROW_HEIGHT} from "../../../../../../styles/Variables";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import {
  AddModalStyles,
  ViewModalStyles,
} from "../../../../../../styles/CustomModalStyles";

import Edit from "../../../../../../images/EditProfile.svg";
import Delete from "../../../../../../images/Delete.svg";
import {ColumnVisibilityFor} from "../../../../../../utils/Enum.Datagrid";
import RfqDetails from "./RfqDetails";
import RfqItems from "./RfqItems";
import SuppliersSelect from "./components/SuppliersSelect";
import {GetSqlNumber} from "../../../../../../queries/queries";
import {
  GetSqlNumberResult,
  GetSqlNumberVars,
  tableKey,
} from "../../../../../../queries/types";
import {useLazyQuery, useMutation} from "@apollo/client";
import {EMPTY_STRING, emptyMessage} from "../../../../../../utils/constants";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {AppContext} from "../../../../../../context/context";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import {GetSupplierByNodeId} from "../../../masters/supplier/queries/queries";
import {nodeVar} from "../../../../../../utils/commonQueryTypes";
import {
  AtsAcLdgr,
  LdgrQueryType,
} from "../../../masters/supplier/queries/types";
import {GetRfqByNode} from "../../quotation/queries/queries";
import {
  AtsRfqMst,
  AtsRfqMstEdge,
  AtsRfqTrn,
} from "../../quotation/queries/types";
import {payloadTypes} from "../../../../../../context/reducer";
import {rfqPoFormData, rfqPoTableData} from "../../../../../../utils/formTypes";
import {
  empType,
  LicenseTypes,
  Operation,
} from "../../../../../../utils/Enum.types";
import {AddPo} from "../../queries/mutations";
import {AddPoResult, AddPoVars} from "../../queries/types";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import MessageModal from "../../../../../../customComponents/MessageModal";
import AddRfqModal from "./components/AddRfqModal";
import Navbar from "../../../../../common/layout/Navbar";
import {useHotKey} from "../../../../../../utils/hotKeys";
import useLabels from "../../../../../../customHooks/useLabels";
const Data = [
  {
    date: "12-03-2024",
    order_no: "34567",
    order_to_supplier: "fg",
  },
];

const RFQtoPO = () => {
  const navigate = useNavigate();
  const {Purchase} = useAssetTableJson();
  const [rfqDetails, setRfqDetails] = useState(false);
  const [itemDescription, setItemDescription] = useState(false);
  const {dispatch} = useContext(AppContext);
  const [selectedRfq, setSelectedRfq] = useState<AtsRfqMstEdge | null>(null);
  const [selectedItm, setSelectedItm] = useState<AtsRfqTrn | null>(null);
  const [items, setItems] = useState<rfqPoTableData[]>([]);
  const [operation, setOperation] = useState(Operation.CREATE);
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const {user_details} = useLoggedInUserDetails();
  const [remarks, setRemarks] = useState("");
  const [addItemModal, setAddItemModal] = useState(false);
  const addRfqRef = useRef<HTMLButtonElement | null>(null);

  const initialValues: rfqPoFormData = {
    slNo: "",
    rfqTrnSlNo: 0,
    udfItemDesc: "",
    itemUom: "",
    itemQty: "",
    itemRate: "",
    itemOther: "",
    itemTaxable: "",
    itemTax: "",
    itemDelvChrg: "",
    itemInstChrg: "",
    itemValue: "",
    remarks: "",
    itemDeliverySts: "",
    itemDeliveryDate: "",
    itemID: 0,
    rfqTrnID: 0,
    rfqID: 0,
    rfqDate: "",
    rfqNo: "",
    netTotal: 0,
  };

  const [formData, setFormData] = useState<rfqPoFormData>(initialValues);

  const {customer_id, company_id} = useUrlParams();

  const {state} = useContext(AppContext);

  const {serverDate} = useServerDateandTime();

  const [GetRfq] = useLazyQuery<{node: AtsRfqMst}, nodeVar>(GetRfqByNode);

  const [GetMrf, {data}] = useLazyQuery<GetSqlNumberResult, GetSqlNumberVars>(
    GetSqlNumber
  );

  const [GetSupplierDetails, {data: SupplierData}] = useLazyQuery<
    {
      node: AtsAcLdgr;
    },
    nodeVar
  >(GetSupplierByNodeId);

  const [AddPurchaseOrder] = useMutation<AddPoResult, AddPoVars>(AddPo, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const dynamicHeaders: TableHeaderProps[] = useMemo(() => {
    return Purchase.PurchaseOrder.RfqToPo.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        if (params.row.id > 1 && header.field === "actions") {
          return (
            <>
              <img
                src={Edit}
                alt=""
                onClick={() => {
                  const foundItem = items.find(
                    (itm, index) => index + 2 === params.row.id
                  );
                  if (foundItem) {
                    handleEdit(foundItem);
                  }
                }}
              />
              <img
                src={Delete}
                alt=""
                onClick={() => {
                  const updatedItems = items.filter(
                    (itm, index) => index + 2 !== params.row.id
                  );
                  setItems(updatedItems);
                }}
              />
            </>
          );
        }
        return params.value;
      },
    }));
  }, [Purchase.PurchaseOrder.RfqToPo, selectedItm, selectedRfq, formData]);

  const columns: GridColDef[] = [...dynamicHeaders];
  const rows: GridValidRowModel[] = [
    ...items.map((data, index) => {
      return {
        id: index + 2, // Start IDs from 2
        approved_rfq_no: data.rfqNo,
        rfq_date: data.rfqDate,
        rfq_sl_no: index + 1,
        item_desc: data.udfItemDesc,
        itemUom: data.itemUom,
        warranty: 0,
        qty: data.itemQty,
        rate: data.itemRate,
        other_charges: data.itemOther,
        taxable_rate: data.itemTaxable,
        tax_perc: data.itemTax,
        total: data.itemValue,
        any_installation: data.itemInstChrg,
        delivery_charges: data.itemDelvChrg,
        deliveryDate: data.itemDeliveryDate,
        net_total: data.itemTaxable + data.itemValue,
        actions: 0,
      };
    }),
  ];

  const getRow = () => {
    if (Data.length) {
      return [
        {
          id: [],
          approved_rfq_no: [],
          rfq_date: [],
          rfq_sl_no: [],
          item_desc: [],
          warranty: "Total",
          qty: 0,
          rate: 0,
          other_charges: 0,
          taxable_rate: 0,
          tax_perc: [],
          total: 0,
          any_installation: 0,
          net_total: 0,
          actions: [],
        },
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow(),
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "other_charges":
        case "rate":
        case "qty":
        case "taxable_rate":
        case "total":
        case "any_installation":
        case "net_total":
          return "total-count";
        case "warranty":
          return "total";
        default:
          return "hide-td";
      }
    }

    return "";
  };

  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    if (customer_id && company_id && state.ActiveFinYr) {
      GetMrf({
        variables: {
          customerID: customer_id,
          companyID: company_id,

          tableKey: tableKey.PO,
        },
      });
    }
  }, [GetMrf, customer_id, state.ActiveFinYr]);
  useEffect(() => {
    GetSupplierDetails({
      variables: {
        id: state.supplierId,
      },
    });
  }, [GetSupplierDetails, state.supplierId]);

  const handleEdit = async (itm: rfqPoTableData) => {
    setOperation(Operation.UPDATE);

    GetRfq({
      variables: {
        id: itm.rfqID,
      },
    }).then(({data}) => {
      if (data && data.node) {
        setSelectedRfq({
          node: data.node,
          cursor: "",
        });
        dispatch({
          type: payloadTypes.SET_RFQ_ID,
          payload: {
            rfqId: data.node.id,
          },
        });
        const foundItem = data.node.rfqTrnDetails.find(
          (trn) => trn.mrf_trn_details.item.id === itm.itemID
        );

        if (foundItem) setSelectedItm(foundItem as AtsRfqTrn);
        const total =
          itm.itemQty * itm.itemRate +
          itm.itemDelvChrg +
          itm.itemInstChrg +
          itm.itemOther;
        setFormData({
          udfItemDesc: itm.udfItemDesc,
          slNo: itm.slNo.toString(),
          rfqTrnSlNo: itm.rfqTrnSlNo,
          itemUom: itm.itemUom,
          itemQty: itm.itemQty.toString(),
          itemRate: itm.itemRate.toString(),
          itemOther: itm.itemOther.toString(),
          itemTaxable: itm.itemTaxable.toString(),
          itemTax: itm.itemTax.toString(),
          itemDelvChrg: itm.itemDelvChrg.toString(),
          itemInstChrg: itm.itemInstChrg.toString(),
          itemValue: itm.itemValue.toString(),
          remarks: itm.remarks,
          itemDeliverySts: itm.itemDeliverySts.toString(),
          itemDeliveryDate: itm.itemDeliveryDate,
          itemID: itm.itemID,
          rfqTrnID: itm.rfqTrnID,
          rfqID: itm.rfqID,
          rfqDate: itm.rfqDate,
          rfqNo: itm.rfqNo,
          netTotal:
            itm.itemQty * itm.itemRate +
            itm.itemDelvChrg +
            itm.itemInstChrg +
            itm.itemOther +
            (itm.itemTax / 100) * total,
        });
      }
    });
    setAddItemModal(true);
  };
  const {itemLabel, ledgerLabel} = useLabels();
  const handleMRFRow = (argFormData: rfqPoFormData) => {
    if (state.rfqId) {
      if (operation === Operation.UPDATE) {
        const filteredItem = items.filter(
          (itm) => itm.slNo !== Number(argFormData.slNo)
        );
        const foundDuplicate = filteredItem.find(
          (itm) =>
            itm.rfqID === argFormData.rfqID && itm.itemID === argFormData.itemID
        );

        if (foundDuplicate) {
          setMessage({
            flag: true,
            message: `${itemLabel} with same rfq already exists`,
            operation: Operation.NONE,
          });
        } else {
          const updateItems: rfqPoTableData[] = items.map((itm) => {
            if (state.rfqId && itm.slNo === Number(argFormData.slNo)) {
              return {
                ...argFormData,
                itemQty: Number(argFormData.itemQty),
                itemRate: Number(argFormData.itemRate),
                itemOther: Number(argFormData.itemOther),
                itemTaxable: Number(argFormData.itemTaxable),
                itemTax: Number(argFormData.itemTax),
                itemValue: Number(argFormData.itemValue),
                itemInstChrg: Number(argFormData.itemInstChrg),
                itemDelvChrg: Number(argFormData.itemDelvChrg),
                slNo: Number(argFormData.slNo),
                itemDeliverySts: Number(argFormData.itemDeliverySts),
                itemDeliveryDate: argFormData.itemDeliveryDate,
              } as rfqPoTableData;
            } else {
              return itm;
            }
          });
          setItems(updateItems);
          setOperation(Operation.CREATE);
        }
      } else {
        const index = items.length;

        const foundDuplicate = items.find(
          (itm) =>
            itm.rfqID === argFormData.rfqID && itm.itemID === argFormData.itemID
        );

        if (foundDuplicate) {
          setMessage({
            flag: true,
            message: `${itemLabel} already exists`,
            operation: Operation.NONE,
          });
        } else {
          if (state.rfqId) {
            setItems((prev) => [
              {
                ...argFormData,
                itemQty: Number(argFormData.itemQty),
                itemRate: Number(argFormData.itemRate),
                itemOther: Number(argFormData.itemOther),
                itemTaxable: Number(argFormData.itemTaxable),
                itemTax: Number(argFormData.itemTax),
                itemValue: Number(argFormData.itemValue),
                itemInstChrg: Number(argFormData.itemInstChrg),
                itemDelvChrg: Number(argFormData.itemDelvChrg),
                slNo: Number(index),
                itemDeliverySts: Number(argFormData.itemDeliverySts),
              },
              ...prev,
            ]);
          }
          setMessage({
            flag: true,
            message: "Added item successfully",
            operation: Operation.CREATE,
          });
        }
      }
    }
    dispatch({
      type: payloadTypes.SET_RFQ_ID,
      payload: {
        rfqId: 0,
      },
    });
    setFormData(initialValues);
  };

  useEffect(() => {
    const savedVisibilityModel = localStorage.getItem(
      ColumnVisibilityFor.RFQ_TO_PO
    );
    if (savedVisibilityModel) {
      try {
        setColumnVisibilityModel(JSON.parse(savedVisibilityModel));
      } catch (e) {
        console.error("Error parsing column visibility model:", e);
        setColumnVisibilityModel({});
      }
    } else {
      setColumnVisibilityModel({});
    }
  }, []);

  useLayoutEffect(() => {
    localStorage.setItem(
      ColumnVisibilityFor.RFQ_TO_PO,
      JSON.stringify(columnVisibilityModel)
    );
  }, [columnVisibilityModel]);

  const handleSubmit = async () => {
    if (customer_id && state.ActiveFinYr && data) {
      AddPurchaseOrder({
        variables: {
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,

          user_details,
          input: {
            poDate: toIsoDate(serverDate),
            poNo: data.GetSqlNumber.sqlNumber,
            remarks,
            poTrns: items.map((itm, index) => {
              const {
                itemDeliveryDate,
                itemDeliverySts,
                slNo,
                rfqDate,
                rfqNo,
                ...rest
              } = itm;
              return {
                itemDeliveryDate: toIsoDate(itm.itemDeliveryDate),
                itemDeliverySts: 0,
                slNo: index + 1,

                ...rest,
              };
            }),
          },
        },
      }).then(({data}) => {
        if (data && data.AddPo) {
          setMessage({
            flag: true,
            message: "Purchase order submitted successfully",
            operation: Operation.CREATE,
          });
        }
      });
    }
  };

  const handleClear = () => {
    setFormData(initialValues);
    setItems([]);
    setRemarks("");
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === "a") {
        setAddItemModal(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useHotKey({
    handleFunc: () => {
      setAddItemModal(!addItemModal);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>RFQ to PO</Title>
      <div className="mrf-to-po">
        <div className="mrf-to-po__details row g-0">
          <div className="col mrf-to-po__details--frame">
            <div className="label-grid">
              <Label>Purchase Order No.</Label>
              <Input
                disabled
                value={data ? data.GetSqlNumber.sqlNumber : EMPTY_STRING}
              />
              <Label>Choose {ledgerLabel}</Label>
              {state.empSubType !== empType.VENDOR_MANAGER ? (
                <div className="mrf-to-po__details--frame--flex">
                  <SuppliersSelect
                    autoFocus={true}
                    onKeyDown={(e) => {
                      if (e.key === Keys.ENTER) {
                        if (addRfqRef.current) addRfqRef.current.focus();
                      }
                    }}
                    icon={true}
                    input={{
                      query_type: LdgrQueryType.ALL,
                      itemID: 0,
                      tableLevel: undefined,
                    }}
                  />
                </div>
              ) : null}
            </div>
            <div className="mrf-to-po__details--frame--grid">
              <Label>GSTIN No.</Label>
              <Input
                disabled
                value={
                  SupplierData
                    ? SupplierData.node.supplier_details.gstNo
                    : EMPTY_STRING
                }
              />

              <Label>City</Label>
              <Input
                disabled
                value={
                  SupplierData
                    ? SupplierData.node.supplier_details.city
                    : EMPTY_STRING
                }
              />
            </div>
          </div>
          <div className="col mrf-to-po__details--frame">
            <div className="label-grid">
              <Label>Date</Label>
              <Input type="date" value={toInputStandardDate(serverDate)} />
            </div>
          </div>
        </div>
        <div className="row g-0">
          <div className="col flex-end">
            <Button
              mode="addnew"
              buttonref={addRfqRef}
              onClick={() => setAddItemModal(!addItemModal)}
            >
              RFQ
            </Button>
          </div>
        </div>
        <div className="mrf-to-po__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            getCellClassName={getCellClassName}
            pinnedRows={pinnedRows}
            getRowClassName={(params) =>
              params.row.id === 1 ? "mrf-to-po__tableblock--edit-row" : ""
            }
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <div className="mrf-to-po__terms row g-0">
          <div className="col">
            <div className="label-grid">
              <Label>Remarks</Label>
              <TextArea
                rows={2}
                value={remarks}
                onChange={(e) => {
                  setRemarks(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="col">
            {/* <div className="label-grid">
              <Label>Terms</Label>
              <Input />
            </div> */}
          </div>
        </div>
        <Button mode="save" onClick={handleSubmit} />
        <Button mode="clear" onClick={handleClear} />
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
      <CustomModal
        isOpen={rfqDetails}
        onRequestClose={() => setRfqDetails(false)}
        contentComponent={<RfqDetails setModalFlag={setRfqDetails} />}
        style={ViewModalStyles}
      />
      <CustomModal
        isOpen={itemDescription}
        onRequestClose={() => setItemDescription(false)}
        contentComponent={<RfqItems setModalFlag={setItemDescription} />}
        style={ViewModalStyles}
      />
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <CustomModal
        isOpen={addItemModal}
        onRequestClose={() => setAddItemModal(!addItemModal)}
        style={AddModalStyles}
        contentComponent={
          <AddRfqModal
            operation={operation}
            hanldeItemRow={handleMRFRow}
            itemsCount={items.length}
            setModal={setAddItemModal}
            formDataState={{
              formData,
              setFormData,
            }}
            editState={{
              editItm: selectedItm,
              editRfq: selectedRfq,
            }}
          />
        }
      />
    </>
  );
};

export default RFQtoPO;
